import Vue from "vue";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import { parseStringPromise } from "xml2js";

const topicFromNode = (node, key) => {
  const nodeChildNode = node && node.node;
  const topicLevel =
    (nodeChildNode && (nodeChildNode.name || nodeChildNode.browseName)) || key || "";
  return topicLevel;
};

const mapNodeWithKey = (node, key) => {
  const newNode = parseNode(node);
  const nodeChild = (newNode && newNode.node && newNode) || { node: newNode };
  const nodeChildNode = nodeChild && nodeChild.node;
  const topicLevel = topicFromNode(nodeChild, key);
  let title = Vue.i18n.translate((nodeChildNode && nodeChildNode.value) || topicLevel || "");

  if (key === "Property") {
    title = `${topicLevel}: ${title}`;
  }

  return { key, title, topicLevel, id: uuidv4(), ...nodeChild };
};

const parseAttributes = node => {
  return Object.entries(node || {})
    .map(([key, value]) => {
      return {
        key: _.camelCase(key),
        value
      };
    })
    .reduce((acc, el) => {
      acc[el.key] = el.value || "";
      return acc;
    }, {});
};

const parseNode = node => {
  return Object.entries(node || {})
    .map(([key, value]) => {
      let result = undefined;

      if (key === "$") {
        result = parseAttributes(value);
      } else if (value) {
        if (Array.isArray(value)) {
          result = (value || []).map(el => {
            return mapNodeWithKey(el, key);
          });
        } else {
          result = mapNodeWithKey(value, key);
        }
      }

      return {
        key,
        value: result
      };
    })
    .reduce((acc, el) => {
      const { key, value } = el;

      if (key === "$") {
        acc = value;
      } else {
        if (!("children" in acc)) {
          acc = { node: { ...acc }, children: [] };
        }

        if (Array.isArray(value)) {
          acc.children = [...acc.children, ...value];
        } else {
          acc.children.push(value);
        }
      }

      return acc;
    }, {});
};

const concatTopic = (topic, topicLevel) => {
  let result = Array.isArray(topic) && topic.length > 0 ? topic[0] : "";

  if (topicLevel !== "ModelDesign") {
    result = (result && `${result}/${topicLevel}`) || topicLevel;
  }

  return result;
};

const fillTopic = (node, topic = []) => {
  const { children } = node;
  const newNode = { ...node, topic };

  if (children) {
    newNode.children = children.map(el => {
      return fillTopic(el, [concatTopic(topic, el.topicLevel)]);
    });
  }

  return { ...newNode, topic };
};

const parseRootToTree = root => {
  const result = fillTopic(parseNode(root));
  let components = result;

  if (result && result.children && result.children.length > 0) {
    components = result.children[0];
  }

  return components;
};

export const parseXMLStringToComponents = async xml => {
  let components = undefined;

  if (xml) {
    const node = await parseStringPromise(xml, { trim: true, normalizeTags: false });
    components = parseRootToTree(node);
  }

  return components;
};
